import React from 'react';
import ReadMore from '../ReadMore';
import './styles.css';

function RoundSection(props) {
  const { content } = props;
  return (
    <div className={'round-hightlight'}>
      {content.icon && (
        <div className="badge">
          <img src={content.icon} alt={'since badge'} />
        </div>
      )}
      {content.image && (
        <div
          className={'round-image'}
          style={{
            backgroundImage: `url('${content.image.sizes.large}')`,
          }}
        />
      )}
      <h4>{content.title}</h4>
      <p>{content.content}</p>
      {content.link && (
        <ReadMore link={content.link}>{content.button_text}</ReadMore>
      )}
    </div>
  );
}

export default RoundSection;
